import { Collapse } from "@material-ui/core";
import React, { useEffect } from "react";

import { FullSite } from "../../../../dtos/site";
import { StatsCountIndicator } from "../StatsCountIndicator";

import { ISSUE_TYPE_LABELS } from "./consts";
import { SitesTable } from "./SitesTable";
import { StatsKey } from "./types";

interface Props {
    statsKey: StatsKey;
    sites: FullSite[];
    itemLabel: string;
    attentionToCount: boolean;
    dealerId: number | null;
}

export function StatsTableRow({
    statsKey,
    sites,
    itemLabel,
    attentionToCount,
    dealerId,
}: Props) {
    const [open, setOpen] = React.useState(false);
    const count = sites.length;

    useEffect(() => {
        if (count === 0) {
            setOpen(false);
        }
    }, [count]);

    return (
        <>
            <tr>
                <td style={{ borderBottom: "unset" }}>
                    {ISSUE_TYPE_LABELS[statsKey]}
                </td>
                <td style={{ borderBottom: "unset", textAlign: "center" }}>
                    <StatsCountIndicator
                        count={sites.length}
                        onClick={() => setOpen(!open)}
                        itemLabel={itemLabel}
                        color={attentionToCount && count > 0 ? "secondary" : "primary"}
                    />
                </td>
            </tr>

            <tr>
                <td
                    style={{
                        padding: 0,
                        margin: 0,
                        borderBottom: open ? "unset" : undefined,
                    }}
                    colSpan={2}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <div style={{ maxWidth: "600px", overflow: "auto" }}>
                            <SitesTable
                                sites={sites}
                                dealerId={dealerId}
                                linkRowToSiteAlarms={statsKey === StatsKey.ActiveAlarm}
                            />
                        </div>
                    </Collapse>
                </td>
            </tr>
        </>
    );
}